
import React, { useState, useRef, useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export default function BonIntervention() {
  const [date, setDate] = useState(() => new Date().toISOString().slice(0, 10));
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [motif, setMotif] = useState('dépannage');
  const [numero, setNumero] = useState('');
  const [remarques, setRemarques] = useState('');
  const [clientEmail, setClientEmail] = useState('');
  const [photos, setPhotos] = useState([]);
  const [duration, setDuration] = useState('');
  const [clientNom, setClientNom] = useState('');
  const [clientAdresse, setClientAdresse] = useState('');
  const [signataire, setSignataire] = useState('');
  const sigCanvas = useRef();
  const formRef = useRef();

  const handlePhotoChange = (e) => {
    setPhotos([...e.target.files]);
  };

  const clearSignature = () => {
    sigCanvas.current.clear();
  };

  useEffect(() => {
    if (startTime && endTime) {
      const [h1, m1] = startTime.split(':').map(Number);
      const [h2, m2] = endTime.split(':').map(Number);
      const total = (h2 * 60 + m2) - (h1 * 60 + m1);
      if (total >= 0) {
        const rounded = Math.ceil(total / 5) * 5;
        setDuration(`${rounded} minutes`);
      } else {
        setDuration('Heure invalide');
      }
    }
  }, [startTime, endTime]);

  const generatePDF = async () => {
    const canvas = await html2canvas(formRef.current);
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF();
    pdf.addImage(imgData, 'PNG', 10, 10, 190, 0);
    return pdf;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const pdf = await generatePDF();
    const pdfBlob = pdf.output('blob');
    const formData = new FormData();
    formData.append('pdf', pdfBlob, 'bon_intervention.pdf');
    formData.append('date', date);
    formData.append('startTime', startTime);
    formData.append('endTime', endTime);
    formData.append('duration', duration);
    formData.append('motif', motif);
    formData.append('numero', numero);
    formData.append('remarques', remarques);
    formData.append('clientEmail', clientEmail);
    formData.append('clientNom', clientNom);
    formData.append('clientAdresse', clientAdresse);
    formData.append('signataire', signataire);
    formData.append('to', JSON.stringify([clientEmail, 'sav@vodolis.fr']));

    photos.forEach((photo, index) => {
      formData.append(`photo${index}`, photo);
    });

    console.log('🚀 Envoi du formulaire avec les données :');
    for (let pair of formData.entries()) {
      console.log(pair[0]+ ': ' + pair[1]);
      appendLog(pair[0]+ ": " + pair[1]);
    }

    const response = await fetch('./send-intervention-report.php', {
      method: 'POST',
      body: formData
    });

    if (response.ok) {
      alert("Bon d'intervention envoyé avec succès au client et au SAV.");
    } else {
      alert("Erreur lors de l'envoi.");
    }
  };

  const appendLog = (msg) => {
  const el = document.getElementById("log-content");
  if (el) el.textContent += msg + "\n";
};

return (
    <div className="container" style={{ maxWidth: '900px', margin: 'auto', padding: '30px', fontFamily: 'Arial', backgroundColor: '#f9f9f9', borderRadius: '8px', boxShadow: '0 0 10px rgba(0,0,0,0.1)' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Bon d'intervention VODOLIS</h2>
      <form ref={formRef} onSubmit={handleSubmit}>
        <label>Date : <input type="date" value={date} onChange={e => setDate(e.target.value)} required /></label><br /><br />
        <label>Heure début : <input type="time" value={startTime} onChange={e => setStartTime(e.target.value)} required /></label><br /><br />
        <label>Heure fin : <input type="time" value={endTime} onChange={e => setEndTime(e.target.value)} required /></label><br />
        <p><strong>Durée :</strong> {duration}</p>
        <label>Motif : 
          <select value={motif} onChange={e => setMotif(e.target.value)}>
            <option value="dépannage">Dépannage</option>
            <option value="chantier">Chantier</option>
          </select>
        </label><br /><br />
        <label>N° SAV / Chantier : <input type="text" value={numero} onChange={e => setNumero(e.target.value)} /></label><br /><br />
        <label>Remarques : <textarea value={remarques} onChange={e => setRemarques(e.target.value)} rows="4" style={{ width: '100%' }} /></label><br /><br />
        <label>Nom du client : <input type="text" value={clientNom} onChange={e => setClientNom(e.target.value)} required /></label><br /><br />
<label>Adresse du client : <input type="text" value={clientAdresse} onChange={e => setClientAdresse(e.target.value)} required /></label><br /><br />
<label>Contact signataire : <input type="text" value={signataire} onChange={e => setSignataire(e.target.value)} /></label><br /><br />
<label>Email du client : <input type="email" value={clientEmail} onChange={e => setClientEmail(e.target.value)} required style={{ width: '100%' }} /></label><br /><br />
        <label>Photos : <input type="file" multiple onChange={handlePhotoChange} /></label><br /><br />

        <div style={{ marginTop: '30px', padding: '20px', backgroundColor: '#fff', border: '2px dashed #ccc', borderRadius: '8px' }}>
          <p><strong>Signature du client :</strong></p>
          <SignatureCanvas ref={sigCanvas} canvasProps={{ width: 600, height: 150, className: 'sigCanvas' }} style={{ border: '1px solid #000' }} />
          <button type="button" onClick={clearSignature} style={{ marginTop: '10px' }}>Effacer la signature</button>
        </div><br />

        <button type="submit" style={{ marginTop: '20px', padding: '10px 20px', fontSize: '16px' }}>Envoyer le bon d'intervention au client et au SAV</button>
      </form>
<div id="debug-log" style="background:#f8f8f8; color:#333; font-family:monospace; font-size:12px; padding:10px; margin-top:20px; max-height:300px; overflow:auto; border:1px solid #ccc;">
  <strong>Logs :</strong>
  <pre id="log-content"></pre>
</div>

    </div>
  );
}
